import { Text } from '@zillow/constellation-10';

import stringHelper from '../../utils/stringHelper';

import type { GetUserPropertyDetailsLocaleSpecificNoticeWebDto } from '@zg-rentals/ts-rental-manager-api-client';

type Props = {
  localeSpecificNotice?: GetUserPropertyDetailsLocaleSpecificNoticeWebDto;
};

const LocaleNotice = ({ localeSpecificNotice }: Props) => {
  if (!localeSpecificNotice?.text || localeSpecificNotice?.text.trim() === '') {
    return null;
  }

  return (
    <Text data-testid="LocaleNotice" textStyle="body-sm">
      {stringHelper.renderWithReplacedLinks(localeSpecificNotice)}
    </Text>
  );
};

export default LocaleNotice;
